// removed by extract-text-webpack-plugin
module.exports = {"modal":"src-components-Messages-Blasts-__MessageShutoff__modal--2YAX3","header":"src-components-Messages-Blasts-__MessageShutoff__header--3bfBb","close":"src-components-Messages-Blasts-__MessageShutoff__close--1ZCSt","disclaimer":"src-components-Messages-Blasts-__MessageShutoff__disclaimer--yVYbT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/Blasts/MessageShutoff.css
// module id = 1966
// module chunks = 0